import { render } from "./Translations.vue?vue&type=template&id=6b7c937c&ts=true"
import script from "./Translations.vue?vue&type=script&lang=ts"
export * from "./Translations.vue?vue&type=script&lang=ts"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__